<template>
  <comment-list-layout v-if="loaded"
                       class="page-weekly-list"
                       ref="commentListLayout"
                       :review-data="review"
                       :render-data="render"
                       @load-comment="fetchReviewExplore"
                       @send-comment="fetchReviewCreate"
                       @like-comment="fetchReviewLike"
                       is-week
  >
    <ym-img class="page-weekly-list-header"
            :src="render.banner"
    />
    <div class="page-weekly-list-summary">
      <span>{{ render.date }}表扬榜发榜啦~</span>
      <span class="underline">共有{{ render.count }}位同学在阅读时长、互动</span>
      <span class="underline">留言和完成挑战任务上表现优异，</span>
      <span>特此表扬,以资鼓励！</span>
    </div>
    <notice-item v-if="fullAttend.count"
                 type="persevere"
    >
      <div class="page-weekly-list-persevere">
        <div class="user-container">
          <div v-for="(item,index) in fullAttend.usernames"
               :item="item"
               :key="index"
               class="user">
            {{ item }}
          </div>
        </div>
        <div class="desc">
          恭喜以上{{ fullAttend.count }}位同学<br>
          在本周中达成连续阅读7天的成就。<br>
          水滴石穿，坚持的你最棒！
        </div>
      </div>
    </notice-item>
    <notice-item v-if="excellentReview.count"
                 type="interaction"
    >
      <div class="page-weekly-list-interaction">
        <div class="user-container">
          <div v-for="(item,index) in excellentReview.list"
               :item="item"
               :key="index"
               class="user">
            <div class="top">
              <ym-img class="avatar"
                      :src="item.avatar"
                      round
              />
            </div>
            <div class="bottom">{{ item.username }}</div>
          </div>
        </div>
        <div class="desc">
          以上这{{ excellentReview.count }}位同学在书籍的留言区<br>
          留下了精彩的思考和回答。<br>
          学习最好的方式是输出，<br>
          每天的阅读后思考也是很重要的哦！
        </div>
      </div>
    </notice-item>
    <notice-item v-if="hardestLearner"
                 type="diligence"
    >
      <div class="page-weekly-list-diligence">
        <div class="avatar-container">
          <ym-img class="avatar"
                  :src="hardestLearner.avatar"
                  round
          />
        </div>
        <div class="desc">
          恭喜<span>{{ hardestLearner.username }}同学</span><br>
          在本周中学习时长{{ hardestLearner.minutes }}分钟，排名第一。<br>
          书山有路勤为径，相信爱读书的你<br>
          一定很有收获！
        </div>
      </div>
    </notice-item>
    <div v-if="work.count"
         class="page-weekly-list-work"
    >
      以下{{ work.count }}位同学完成的作品很棒<br>一起来互相学习下吧！
    </div>
    <work-item v-for="(item,index) in work.list"
               :item="item"
               :key="index"
    />
    <div class="page-weekly-list-footer"
         :class="{ 'up': work.count }"
    >
      <div class="top">
        本期表扬榜就到此为止啦～<br>
        希望同学们努力学习，多多交流，争取下一次上榜！<br>
        有问题可以在「个人中心」中找「辅导老师」询问。<br>
        我们下期再见～
      </div>
      <div class="bottom">
        温馨提示：可截图保存分享<br>
        已有90%的同学发送到朋友圈了
      </div>
    </div>
  </comment-list-layout>
</template>

<script>
  import NoticeItem from '@/pages/MillionRead/components/NoticeItem';
  import WorkItem from '@/pages/MillionRead/components/WorkItem';
  import CommentListLayout from '@/layout/CommentListLayout';
  import {
    getWeeklyReport,
    weeklyReviewExplore,
    weeklyReviewCreate,
    weeklyReviewLike,
  } from '@/services/million-read';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'WeeklyListIndex',
    metaInfo: {},
    components: {
      NoticeItem,
      WorkItem,
      CommentListLayout,
    },
    data() {
      return {
        loaded: false,
        render: null,
        fullAttend: null,
        excellentReview: null,
        hardestLearner: null,
        work: null,
        review: null,
        reviewStart: 0,
      };
    },
    computed: {
      reportId() {
        return this.$route.params.id || 0;
      },
    },
    methods: {
      async fetchData() {
        const data = await getWeeklyReport(this.reportId);
        this.render = data.render;
        this.review = data.review;
        this.reviewStart = data.review.start;
        this.fullAttend = data.fullAttend;
        this.excellentReview = data.excellentReview;
        this.hardestLearner = data.hardestLearner;
        this.work = data.work;
        this.loaded = true;
      },
      async fetchReviewExplore() {
        const params = {
          reportId: this.reportId,
          start: this.reviewStart,
          limit: LIMIT,
          requestTime: this.review.requestTime,
        };
        const data = await weeklyReviewExplore(params);
        this.reviewStart = data.start;
        this.$refs.commentListLayout.handleFetchData('loadComment', data);
      },
      async fetchReviewCreate(replyId, content) {
        const data = await weeklyReviewCreate(replyId, content, this.reportId);
        this.reviewStart += 1;
        this.$refs.commentListLayout.handleFetchData('sendComment', data);
      },
      async fetchReviewLike(item) {
        const action = item.like.liked ? 'unlike' : 'like';
        await weeklyReviewLike(item.id, action);
        this.$refs.commentListLayout.handleFetchData('likeComment', item);
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-weekly-list {
    min-height: 100%;
    background: #FFE0A1;
    &-header {
      width: 100%;
      height: 841px;
    }
    &-summary {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 527px;
      background: url('~@/assets/img/million_read/weekly/summary_bg.png');
      background-size: 100%;
      margin-bottom: 77px;
      color: #3c1a13;
      font-size: 33px;
      span {
        line-height: 60px;
        &.underline {
          color: #ce2013;
          padding-bottom: 2px;
          border-bottom: 1px solid #ce2013;
        }
      }
    }
    &-persevere {
      .user-container {
        display: flex;
        flex-wrap: wrap;
        padding: 20px 100px;
        box-sizing: border-box;
        .user {
          width: 175px;
          color: #0d5746;
          font-size: @font-size-base;
          text-decoration: underline;
          margin-bottom: 30px;
          text-align: center;
          padding: 0 2px;
        }
      }
      .desc {
        color: #353535;
        font-size: @font-size-base;
        line-height: 48px;
        text-align: center;
      }
    }
    &-interaction {
      .user-container {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-around;
        padding: 30px 110px 50px;
        .user {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          margin-bottom: 30px;
          width: 150px;
          .top {
            display: flex;
            justify-content: center;
            width: 120px;
            height: 120px;
            background: url('~@/assets/img/million_read/weekly/avatar.png');
            background-size: 100%;
            .avatar {
              width: 70px;
              height: 70px;
              margin-top: 18px;
            }
          }
          .bottom {
            width: 100%;
            color: #282828;
            font-size: @font-size-small;
            text-align: center;
            margin-top: 5px;
          }
        }
      }
      .desc {
        color: #353535;
        font-size: @font-size-base;
        line-height: 48px;
        text-align: center;
      }
    }
    &-diligence {
      .avatar-container {
        display: flex;
        justify-content: center;
        width: 178px;
        height: 178px;
        background: url('~@/assets/img/million_read/weekly/avatar.png');
        background-size: 100%;
        margin-bottom: 18px;
        margin-left: 287px;
        .avatar {
          width: 107px;
          height: 107px;
          margin-top: 25px;
        }
      }
      .desc {
        color: #353535;
        font-size: @font-size-base;
        line-height: 48px;
        text-align: center;
        span {
          color: #4f6cb7;
          text-decoration: underline;
        }
      }
    }
    &-work {
      width: 100%;
      height: 147px;
      box-sizing: border-box;
      margin-bottom: 46px;
      background-image: url('~@/assets/img/million_read/weekly/work_title_bg.png');
      background-size: 100%;
      color: #fffbe9;
      font-size: 35px;
      padding-left: 50px;
      padding-top: 30px;
      text-align: center;
    }
    &-footer {
      position: relative;
      width: 100%;
      height: 840px;
      background-image: url('~@/assets/img/million_read/weekly/footer_bg.png');
      background-size: 100%;
      &.up {
        margin-top: -250px;
      }
      .top {
        position: absolute;
        top: 372px;
        left: 112px;
        color: @color-white;
        font-size: @font-size-small;
        line-height: 43px;
      }
      .bottom {
        position: absolute;
        left: 206px;
        bottom: 78px;
        color: #fff4b9;
        font-size: @font-size-small;
        line-height: 37px;
        text-align: center;
      }
    }
  }
</style>
